export const CalorieRing = ({ percent = 62, label = "1240", sub = "kcal left" }) => {
  const radius = 42;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;
  return (
    <div className="relative w-28 h-28 flex items-center justify-center" data-testid="calorie-ring">
      <svg width="112" height="112" viewBox="0 0 100 100" className="-rotate-90">
        <circle cx="50" cy="50" r={radius} stroke="#232326" strokeWidth="8" fill="none" />
        <circle
          cx="50"
          cy="50"
          r={radius}
          stroke="#C6FF3D"
          strokeWidth="8"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="text-white font-display text-lg leading-none">{label}</span>
        <span className="text-[#A1A1AA] text-[10px] mt-1">{sub}</span>
      </div>
    </div>
  );
};
